import React, { useEffect } from 'react';
import './App.css';
import Home from './components/Home';
import About from './components/About';
import Skills from './components/Skills';
import Services from './components/Services';
import Portfolio from './components/Portfolio';

function App() {
  useEffect(() => {
    const scrollWithOffset = (el) => {
      const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
      const yOffset = -60; // Adjust as needed, considering fixed header height
      window.scrollTo({ top: yCoordinate + yOffset, behavior: 'smooth' });
    };

    const handleScroll = () => {
      const header = document.querySelector('header');
      if (header) {
        const isScrolled = window.scrollY > 0;
        if (isScrolled) {
          header.classList.add('scrolled');
        } else {
          header.classList.remove('scrolled');
        }
      }
    };

    document.querySelectorAll('header nav ul li a').forEach(anchor => {
      anchor.addEventListener('click', function(e) {
        e.preventDefault();
        const sectionId = this.getAttribute('href').substring(1);
        const section = document.getElementById(sectionId);
        if (section) {
          scrollWithOffset(section);
        }
      });
    });

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className="App">
      <header>
        <nav>
          <div className="header-content">
            <p className="name">Ashish Kumar</p>
            <ul>
              <li><a href="#home">Home</a></li>
              <li><a href="#about">About</a></li>
              <li><a href="#skills">Skills</a></li>
              <li><a href="#portfolio">Portfolio</a></li>
              <li><a href="#services">Services</a></li>
            </ul>
          </div>
        </nav>
      </header>
      <main>
        <section id="home" className="section">
          <Home />
        </section>
        <section id="about" className="section">
          <About />
        </section>
        <section id="skills" className="section">
          <Skills />
        </section>
        <section id="portfolio" className="section">
          <Portfolio />
        </section>
        <section id="services" className="section">
          <Services />
        </section>
      </main>
    </div>
  );
}

export default App;
